import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssinaturaModule } from '../assinatura/assinatura.module';
import { AssinaturaComponent } from './assinatura.component';

const routes: Routes = [
  {
    path: '',
    component: AssinaturaComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssinaturaPageRoutingModule {}
